module.exports = __webpack_public_path__ + "img/3.76b53942.jpg";